import {View, Sync} from 'MWC';
import quickCashOrderModel from '../models/quickCashOrder.m.js';
import tpl from '../templates/interactive.jsx';
import {apiback} from 'config';
import {formatter, IPhone} from 'MWComponents';

const data = {
    contactPhoneNumber: '+380',
    passwordOTP: null
};
const backspace = 'Backspace';
const initValue = '+38 (0';

export default class extends View {
    template = tpl;

    constructor() {
        super();
        this.state = {
            activeScreen: 'form',
            model: new quickCashOrderModel(data),
            repeatOTPbutton: false,
            errorMessage: '',
            sendOTPerrorMessage: ''
        };

        this._initMethods();
    }

    handleChange(event) {
        const data = {
            name: event.target.name,
            value: event.target.value
        };

        this._run(data);
    }

    onKeyDown(event) {
        const control = event.target;
        const data = {
            name: control.name,
            value: control.value
        };
        const dedicatedValue = data.value.substring(control.selectionStart, control.selectionEnd);
        if ((data.value === initValue && event.key === backspace) || dedicatedValue.length > 0) {
            event.preventDefault();
            this._run(data);
        }
    }

    _run(data) {
        const model = this.getModel();
        model.run({name: data.name, value: data.value});
        this.setState({model});
    }

    onBlurHandle(name) {
        const model = this.getModel();
        model.changeFirst(name);
        model.validate();
        this.setState({model});
    }

    handleEscape(event) {
        if (event.keyCode === 27) {
            this.closeModal();
        }
    }
    repeatOTP = () => {
        window.setTimeout(() => this.setState({repeatOTPbutton: true}), 300000);
    };

    closeModal(event) {
        event ? event.stopPropagation() : this.props.closeModal();

        const target = event && event.target,
            classesToClose = ['form-wrapper', 'close-button', 'btn-transparent'];

        if (target && classesToClose.some(className => target.classList.contains(className))) {
            this.props.closeModal();
        }
    }

    _phoneFormat = value => {
        if (value instanceof IPhone) {
            return value.toString('contact');
        } else {
            return formatter(value, '+{{dd}} ({{ddd}}) {{ddd}} {{dd}} {{dd}}');
        }
    };

    removeBracketsAndSpaces(phoneNumber) {
        phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '');

        phoneNumber = phoneNumber.replace(/\s/g, '');

        return phoneNumber;
    }

    async sendForm() {
        const {contactPhoneNumber} = this.getModel().fields,
            Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            // url = 'http://a-bank-dev9.ab.loc/api/v1/a-express-credit-application',
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        phone: this.removeBracketsAndSpaces(contactPhoneNumber.value),
                        step: 'sendOtp',
                        utmMarks: this.props.utmParams
                    },
                    hash: '72FA32SAA97B3123'
                },
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else if (response.data.data.status === 'error') {
                this.setState({
                    sendOTPerrorMessage: response.data.data.error
                });
            } else {
                window.dataLayer.push({event: 'sendgreenform'});
                this.setState({
                    activeScreen: 'checkOTP'
                });
                this.repeatOTP();
            }
        } catch (error) {
            this.setState({
                activeScreen: 'error'
            });
            return error;
        }
    }

    async sendOTP() {
        const {passwordOTP, contactPhoneNumber} = this.getModel().fields,
            Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            // url = 'http://a-bank-dev9.ab.loc/api/v1/a-express-credit-application',
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        phone: this.removeBracketsAndSpaces(contactPhoneNumber.value),
                        step: 'checkOtp',
                        password: passwordOTP.value,
                        source: 'credit/quick_cash',
                        loanSum: this.props.loanSum,
                        loanTerm: this.props.loanTerm
                    },
                    hash: '72FA32SAA97B3123'
                },
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else if (response.data.data.status === 'error') {
                this.setState({
                    errorMessage: response.data.data.error
                });
            } else {
                window.dataLayer.push({event: 'sendgreenform'});
                this.setState({
                    activeScreen: 'success'
                });
            }
        } catch (error) {
            this.setState({
                activeScreen: 'error'
            });
            return error;
        }
    }

    _initMethods() {
        this.handleChange = this.handleChange.bind(this);
        this.onBlurHandle = this.onBlurHandle.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.sendOTP = this.sendOTP.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleEscape);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleEscape);
    }

    static displayName = 'Quick.Cash.Order';
}
